/**
 * Created by Daniela on 29/11/2016.
 */
export class Seguro {
  ativo: boolean;
  id: number;
  bonus: string;
  inicioVigor: string;
  numeroApolice: string;
  vencimento: string;
  bemId: number;
  seguradoraId: number;
  valorSegurado: number;
  valorSeguro: number;
  descricao: string;
  observacao: string;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguros/shared/seguro.model.ts
 **/